define(['jquery', 'globalVars', 'hoverintent'], ($, { $body, $html }) => {
    return {
        settings: {
            navigationItem: '.js-menu-nav-item',
            classMenuOpen: '_menu-open',
            classOpen: '_open',
            classSubmenu: '_submenu',
        },

        init() {
            this.bindEvents();
            this.initMenuDesktop();
        },

        bindEvents() {
            $body.on('change-state', this.changeState.bind(this));
        },

        _openMenu() {
            $html.addClass(this.settings.classMenuOpen);
        },

        _closeMenu(ev) {
            ev && ev.preventDefault();

            $html.removeClass(this.settings.classMenuOpen);
        },

        initMenuDesktop() {
            const $topLevelItems = $(this.settings.navigationItem).filter(
                '.level0'
            );

            $topLevelItems.hoverIntent({
                //sensitivity: 3,
                //interval: 50,
                timeout: 100,
                over: el => {
                    const $target = $(el.currentTarget);
                    const $images = $target.find('.js-lazy');

                    $images.each((index, el) => {
                        $(el).attr('src', $(el).data('lazy-src'));
                        $(el).removeClass('js-lazy');
                    });

                    this._openMenu();

                    $(this.settings.navigationItem).removeClass(
                        this.settings.classOpen
                    );
                    $target.addClass(this.settings.classOpen);
                },
                out: el => {
                    const $target = $(el.currentTarget);

                    $target.removeClass(this.settings.classOpen);

                    const openedItem = $(this.settings.navigationItem).filter(
                        `.${this.settings.classOpen}`
                    );

                    !openedItem.length && this._closeMenu();
                },
            });
        },

        changeState() {
            $html.removeClass(this.settings.classMenuOpen);
        },
    };
});
